import {
  AppKeys,
  newMsg,
  msgNumDevice,
  newTag,
} from '../../../core/localization';
export const msgHeaderSend = newMsg(AppKeys.Tx_Send_Header);
export const msgHeaderReq = newMsg(AppKeys.Tx_Req_Header);
export const msgHeaderActivities = newMsg(AppKeys.Tx_Act_Header);
export const msgHeaderDetails = newMsg(AppKeys.Tx_Detail_Header);

export const msgContinueBtn = newMsg(AppKeys.Btn_Continue);
export const msgRetryBtn = newMsg(AppKeys.Btn_Retry);
export const msgSendNowBtn = newMsg(AppKeys.Tx_Send_Btn_Now);
export const msgGetCodeHelper = newMsg(AppKeys.Tx_Usercode_Helper_Get);
export const msgBtnGetCode = newMsg(AppKeys.Tx_Usercode_Btn_Get);
export const msgCodeLabel = newMsg(AppKeys.Tx_Usercode_Code_Label);
export const msgCodeResend = newMsg(AppKeys.Tx_Usercode_Btn_Resend);
export const msgAddDeviceBtn = newMsg(AppKeys.Btn_AddToList);
export const msgRequestNowBtn = newMsg(AppKeys.Tx_Req_Btn_Now);
export const msgBtnAccept = newMsg(AppKeys.Btn_Accept);
export const msgBtnDeny = newMsg(AppKeys.Btn_Deny);
export const msgBtnCancel = newMsg(AppKeys.Btn_Cancel);
export const msgActivitiesBtn = newMsg(AppKeys.Tx_Act);
export const msgDevice = msgNumDevice;
export const msgSentTo = newMsg(AppKeys.Tx_Send_SendTo);
export const msgSent = newMsg(AppKeys.Tx_Send_Sent);
export const msgReceived = newMsg(AppKeys.Tx_Act_Received);
export const msgRequest = newMsg(AppKeys.Tx_Req);
export const msgRequested = newMsg(AppKeys.Tx_Req_Requested);
export const msgSelected = newMsg(AppKeys.Com_Selected);

export const msgSnLabel = newMsg(AppKeys.Device_Prop_SeriaNumber);
export const msgSnPH = newMsg(AppKeys.PH_SerialNumber);

export const msgDeviceLabel = newMsg(AppKeys.Com_Devices);

export const msgValidating = newMsg(AppKeys.Com_Validating);
export const msgGettingCode = newMsg(AppKeys.Tx_Usercode_Code_Requesting);
export const msgCheckingCode = newMsg(AppKeys.Tx_Usercode_Code_Validating);
export const msgTransfering = newMsg(AppKeys.Tx_Send_Transfering);
export const msgCreatingTx = newMsg(AppKeys.Tx_Req_Creating);

export const msgBadFormatSN = newMsg(AppKeys.Register_BadFormat_SN_Error);
export const msgInvalidDeviceError = newMsg(AppKeys.Tx_Req_InvalidDevice_Error);
export const msgDuplicateError = newMsg(AppKeys.Tx_Req_Duplicated_Error);
export const msgValidatingError = newMsg(AppKeys.Tx_Req_Validating_Error);
export const msgGettingCodeError = newMsg(
  AppKeys.Tx_Usercode_Code_Requesting_Error
);
export const msgCheckingCodeError = newMsg(
  AppKeys.Tx_Usercode_Code_Validating_Error
);
export const msgTransferingError = newMsg(AppKeys.Tx_Send_Transfering_Error);
export const msgCreatingTxError = newMsg(AppKeys.Tx_Req_Creating_Error);
export const msgGetDetailsTxError = newMsg(AppKeys.Tx_Detail_Fetching_Error);
export const msgReqAcceptedError = newMsg(AppKeys.Tx_Act_Accept_Error);
export const msgReqDenyError = newMsg(AppKeys.Tx_Act_Deny_Error);
export const msgReqCancelError = newMsg(AppKeys.Tx_Act_Cancel_Error);

export const msgSendTransferSucceed = newMsg(AppKeys.Tx_Send_Transfering_Ok);
export const msgReqTransferSucceed = newMsg(AppKeys.Tx_Req_Creating_Ok);
export const msgReqAcceptedSucceed = newMsg(AppKeys.Tx_Act_Accept_Ok);
export const msgReqDenySucceed = newMsg(AppKeys.Tx_Act_Deny_Ok);
export const msgReqCancelSucceed = newMsg(AppKeys.Tx_Act_Cancel_Ok);


export const msgSumamryHeaderReq = newMsg(AppKeys.Tx_Req_Sum_Title);
export const msgSumamryHeaderSend= newMsg(AppKeys.Tx_Send_Sum_Title);
export const msgSumamryTo = newMsg(AppKeys.Com_To);
export const msgSumamryKeys = (count: number) =>
  newMsg(AppKeys.Num_EncryptionKeys, [newTag('count', count)]);
